import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Message} from 'semantic-ui-react';

function Ranks(props) {
  const {student} = props;

  if (!student.showRanks) return null;
  if (!student.meanStudyTime) return null;
  if (!student.rankByStudyTime) return null;

  return (
    <Message className='text-center'>
      <span>شما با میانگین مطالعه </span>
      <span className='text-bold'>{student.meanStudyTime}</span>
      <span> در 2 هفته گذشته </span>
      <span className='text-bold'>{`رتبه ${student.rankByStudyTime} `}</span>
      <span> را در بین داوطلبان </span>
      <span className='text-bold'>{student.type.name}</span>
      <span> کسب کرده اید.</span>
    </Message>
  );
}

function mapStateToProps({student}) {
  return {student: student.data};
}

Ranks.propTypes = {
  student: PropTypes.object
};

export default connect(mapStateToProps)(Ranks);
